/* eslint @typescript-eslint/no-explicit-any: 0 */

export interface IWebSocketMessage {
    headers: {
        request?: string;
        response?: string;
        authorization?: string;
        correlationId?: string;
        operator?: string;
    };
    payload: any;
}

export enum WebSocketMessageType {
    BackendConnectionStatusChange = 'BackendConnectionStatusChange',
    ErrorHandling = 'ErrorHandling',
    LogMessage = 'LogMessage',
    GeneralMessage = 'GeneralMessage',
    Time = 'Time',
    Terminals = 'Terminals',
    CenterlineGroups = 'CenterlineGroups',
    Centerlines = 'Centerlines',
    CenterlineObjectUnsubscribe = 'CenterlineObjectUnsubscribe',
    Flights = 'Flights',
    Docking = 'Docking',
    Command = 'Command',
    ConMon = 'ConMon',
    ErrorLogs = 'ErrorLogs',
    EventLogs = 'EventLogs',
    Statistics = 'Statistics',
    MaintenanceContext = 'MaintenanceContext',
    MaintenanceTestCommand = 'MaintenanceTestCommand',
    MaintenanceModeContext = 'MaintenanceModeContext',
    MaintenanceLinks = 'MaintenanceLinks',
    MaintenanceCommands = 'MaintenanceCommands',
    MaintenanceCommand = 'MaintenanceCommand',
    MaintenanceFailedTests = 'MaintenanceFailedTests',
    MaintenanceComponents = 'MaintenanceComponents',
    MaintenanceSchedule = 'MaintenanceSchedule',
    MaintenanceTasksCompleted = 'MaintenanceTasksCompleted',
    MaintenanceTaskCompleted = 'MaintenanceTaskCompleted',
    MaintenanceMode = 'MaintenanceMode',
    MaintenanceDocking = 'MaintenanceMode',
    RegisterClient = 'RegisterClient',
    UnregisterClient = 'UnregisterClient',
    RequestHeartbeat = 'RequestHeartbeat',
    ResponseHeartbeat = 'ResponseHeartbeat',
    License = 'License',
    LicenseUsage = 'LicenseUsage',
    SiemEvent = 'SiemEvent'
}
